import * as React from 'react'

import { ApolloProvider } from '@apollo/client'
import { observer, Provider } from 'mobx-react'
import { BrowserRouter } from 'react-router-dom'

import RootStore from '../stores/Root.store'
import { resetKeyedToasts, toastManager } from '../utils/toast'
import ErrorBoundary from './ErrorBoundary'
import { Toaster } from './shadcn-ui/toast'
import { TooltipProvider } from './shadcn-ui/tooltip'

interface AppProviderProps {
  rootStore: RootStore
  // Layout-only: lets an app lift the toast viewport clear of its own bottom chrome.
  toastViewportClassName?: string
}
@observer
export default class AppProvider extends React.Component<AppProviderProps> {
  public componentDidMount(): void {
    resetKeyedToasts()
  }

  public render() {
    const { rootStore, children, toastViewportClassName } = this.props
    const { graphClient } = rootStore.state

    return (
      <ApolloProvider client={graphClient}>
        <Provider {...rootStore}>
          <BrowserRouter>
            <TooltipProvider>
              <ErrorBoundary>{children}</ErrorBoundary>
            </TooltipProvider>
            <Toaster
              toastManager={toastManager}
              viewportClassName={toastViewportClassName}
            />
          </BrowserRouter>
        </Provider>
      </ApolloProvider>
    )
  }
}
